var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Message } from 'packages/email/entities/Message';
import { EntityBuilder } from '@decahedron/entity';
import env from 'config/env';
var MessageRepository = /** @class */ (function (_super) {
    __extends(MessageRepository, _super);
    function MessageRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = Message;
        _this.url = 'mail/:messageId';
        _this.baseUrl = env.JOBILLA_API_V2_URL;
        return _this;
    }
    MessageRepository.prototype.markMessageRead = function (messageId) {
        return this.axios.post(this.baseUrl + "mail/" + messageId, { read: true, _method: 'PATCH' })
            .then(function (response) { return EntityBuilder.buildOne(Message, response); });
    };
    return MessageRepository;
}(AbstractRepository));
export { MessageRepository };
